module.exports = __webpack_public_path__ + "img/doorLogo20.a2d74c9f.png";